export default function Jurisdiction() {
  return <section id="jurisdiction" className="relative w-full min-h-[500px] bg-primary overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576388/img/port_terminal_drone_shot.png)] bg-cover bg-center opacity-20 grayscale contrast-125 mix-blend-luminosity pointer-events-none"></div>

      {}
      <div className="container mx-auto px-6 md:px-12 relative z-10 w-full">
        <div className="max-w-3xl">
        </div>
      </div>

      {}
      <div className="absolute bottom-8 right-6 md:bottom-12 md:right-12 z-10 pointer-events-none">
        <p className="font-mono text-lg md:text-2xl text-primary-foreground/90 text-right tracking-tight drop-shadow-md">
          Compliance: EU GDPR / Asturias, Spain
        </p>
      </div>
    </section>;
}